import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ContentChild,
  TemplateRef,
  booleanAttribute,
  input,
} from '@angular/core';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle
} from '@angular/material/dialog';
import { PayeeButtonComponent } from '../payee-buttons/payee-button/payee-button.component';

/**
 * Payee dialog chrome on Material M3 layout directives.
 *
 * Visual card (padding, background, radius, shadow) lives on this host.
 * Material surface (`.payee-dialog` panelClass) stays layout-only.
 * Width/maxWidth are CSS variables on the host — no MatDialog.updateSize().
 *
 * @see https://v21.material.angular.dev/components/dialog/overview
 */
@Component({
  selector: 'payee-popup',
  templateUrl: './payee-popup.component.html',
  styleUrls: ['./payee-popup.component.scss'],
  imports: [
    NgTemplateOutlet,
    PayeeButtonComponent,
    MatDialogTitle,
    MatDialogActions,
    MatDialogClose,
  ],
  host: {
    class: 'payee-popup',
  },
})
export class PayeePopupComponent {
  readonly title = input<string>();
  readonly description = input<string>();
  readonly width = input('min-content');
  readonly stackedActions = input(true, { transform: booleanAttribute });

  readonly onSubmit = input<(() => void) | undefined>();
  readonly onCancel = input<(() => void) | undefined>();

  @ContentChild('payeePopupTitleTemplate')
  titleTemplateRef?: TemplateRef<unknown>;

  @ContentChild('payeePopupDescriptionTemplate')
  descriptionTemplateRef?: TemplateRef<unknown>;

  @ContentChild('payeePopupSubmitTemplate')
  submitTemplateRef?: TemplateRef<unknown>;

  @ContentChild('payeePopupCancelTemplate')
  cancelTemplateRef?: TemplateRef<unknown>;

  get hasTitle(): boolean {
    return !!this.titleTemplateRef || !!this.title();
  }

  get hasDescription(): boolean {
    return !!this.descriptionTemplateRef || !!this.description();
  }
}
